export type MiningActivityType = 'explotacion' | 'beneficio'

/**
 * Infiere el tipo de actividad de un derecho minero a partir de su nombre:
 * los derechos de planta de beneficio incluyen "ACTIVIDAD DE BENEFICIO".
 * Cualquier otro caso se trata como explotación.
 */
export function getMiningActivityType(miningRightName: string | null | undefined): MiningActivityType {
  return (miningRightName ?? '').toUpperCase().includes('BENEFICIO') ? 'beneficio' : 'explotacion'
}
